import UIButton from "@material-ui/core/Button";
import { cloneElement, useMemo } from 'react';
import * as React from "react";
import PropTypes from 'prop-types';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Button,
    sanitizeListRestProps,
} from 'react-admin';
import {Box} from "@material-ui/core";

const handleCsvClick = (scope) => {
    let afterInput = document.getElementById('dispensedAt[after]');
    let beforeInput = document.getElementById('dispensedAt[before]');
    let divisionInput = document.getElementsByName('division')[0];

    let after = afterInput ? afterInput.value : '';
    let before = beforeInput ? beforeInput.value : '';
    let division = divisionInput ? divisionInput.value : '';

    window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/reimbursement/report/xlsx?'
        + 'scope=' + scope
        + '&from=' + after
        + '&to=' + before
        + '&division=' + division
        + '&token=' + localStorage.getItem('session');
}

const handleCsvClickAll = () => {
    handleCsvClick('all');
}

const handleCsvClickReimbursement = () => {
    handleCsvClick('reimbursement');
}

const handleCsvClickInsulins = () => {
    handleCsvClick('insulins');
}

const Actions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <div>
                <Box component="span" mr={1} ml={4}>
                    <UIButton variant="outlined" color="primary" onClick={handleCsvClickAll}>
                        Усі
                    </UIButton>
                </Box>
                <Box component="span" mr={1} ml={1}>
                    <UIButton variant="outlined" color="primary" onClick={handleCsvClickReimbursement}>
                        Реімбурсація
                    </UIButton>
                </Box>
                <Box component="span" mr={2} ml={1}>
                    <UIButton variant="outlined" color="primary" onClick={handleCsvClickInsulins}>
                        Інсуліни
                    </UIButton>
                </Box>
            </div>
        </TopToolbar>
    );
};

export default Actions;